import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import * as API from '../apiConfig';


function LoginComponent({ onLogin }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: location.state?.email || '',
    password: '',
  });
  const [error, setError] = useState('');
  const [successMessage] = useState(location.state?.successMessage || '');
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = ({ target: { name, value } }) => {
    setFormData((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const response = await fetch(`${API.AUTH_API_URL}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Login failed');
      }

      onLogin({
        email: formData.email,
        token: data.token,
        message: data.message,
      });
      navigate('/home', { replace: true });
    } catch (submitError) {
      setError(submitError.message || 'Unable to login right now');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-12 col-md-10 col-lg-8 col-xl-6">
            <div className="card auth-card border-0 shadow-lg">
              <div className="card-body p-4 p-md-5">
                <p className="auth-kicker mb-2">Billing System</p>
                <h1 className="h2 fw-bold mb-3">Welcome back</h1>
                <p className="text-secondary mb-4">
                  Login with the account you registered using your backend API.
                </p>

                {successMessage && (
                  <div className="alert alert-success" role="alert">
                    {successMessage}
                  </div>
                )}

                {error && (
                  <div className="alert alert-danger" role="alert">
                    {error}
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label" htmlFor="login-email">
                      Email address
                    </label>
                    <input
                      id="login-email"
                      name="email"
                      type="email"
                      className="form-control form-control-lg"
                      placeholder="name@example.com"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="mb-4">
                    <label className="form-label" htmlFor="login-password">
                      Password
                    </label>
                    <input
                      id="login-password"
                      name="password"
                      type="password"
                      className="form-control form-control-lg"
                      placeholder="Enter your password"
                      value={formData.password}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <button
                    type="submit"
                    className="btn btn-primary btn-lg w-100"
                    disabled={isLoading}
                  >
                    {isLoading ? 'Signing in...' : 'Login'}
                  </button>
                </form>

                <p className="text-center text-secondary mt-4 mb-0">
                  Need an account? <Link to="/register">Create one</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginComponent;
